export const setCustomTimeout = (callback: () => void, duration: number) => {
  const timeoutId = window.setTimeout(callback, duration);
  return () => window.clearTimeout(timeoutId);
};
